import { render } from "./Customization.vue?vue&type=template&id=7afb6b00"
import script from "./Customization.vue?vue&type=script&lang=js"
export * from "./Customization.vue?vue&type=script&lang=js"
script.render = render

export default script